module.exports = __webpack_public_path__ + "494cd07c/img/note-list-icon.961c1485.svg";